(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
  const rootPath = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const route = path => rootPath + path.replace(/^\//, '');
  const currency = () => window.Shopify?.currency?.active || 'EUR';
  const delayedDeliveryHandles = new Set(["distributeur-croquettes-automatique-chat-2l-boutons","distributeur-croquettes-automatique-chat-2l-wifi","distributeur-croquettes-automatique-chat-2l-camera","filtres-fontaine-eau-chat-inox"]);
  const money = (cents, code = currency()) => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: code }).format(Number(cents || 0) / 100);
  const parse = node => { try { return node ? JSON.parse(node.textContent) : null; } catch { return null; } };
  const norm = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const dataNode = $('#cocon-product-data');
  const rawProduct = parse(dataNode);
  const isCents = dataNode?.dataset.moneyUnit !== 'euros';
  const product = rawProduct ? {
    ...rawProduct,
    options: (rawProduct.options || []).map((option, index) => typeof option === 'string' ? { name: option, position: index + 1 } : { ...option, position: option.position || index + 1 }),
    variants: (rawProduct.variants || []).map(variant => {
      const options = variant.options || [variant.option1, variant.option2, variant.option3].filter(value => value != null);
      return { ...variant, id: String(variant.id), price: Math.round(Number(variant.price || 0) * (isCents ? 1 : 100)), compare_at_price: Math.round(Number(variant.compare_at_price || 0) * (isCents ? 1 : 100)), options, option1: options[0], option2: options[1], option3: options[2] };
    })
  } : null;
  const primary = $('[data-cocon-primary]') || $('#MainContent form [name="add"]');
  const form = primary?.form;
  const field = form ? $('[name="id"]', form) : null;
  const sticky = $('.cocon-sticky');
  const formulas = $('[data-inox-formulas]');
  const packFormulas = $('[data-kitteen-pack-formulas]');
  const openComplementRoot = $('[data-cocon-open-complements]');
  if (sticky && !$('[data-cocon-sticky-delivery]', sticky)) {
    const delivery = document.createElement('small');
    delivery.setAttribute('data-cocon-sticky-delivery', '');
    delivery.textContent = 'Livraison offerte';
    $('.cocon-sticky-info', sticky)?.append(delivery);
  }
  let adding = false;
  let changing = false;
  let cart = null;
  let paintFrame = 0;
  let availabilityKey;

  const selected = () => product?.variants.find(variant => variant.id === String(field?.value || '')) || (field?.value ? null : product?.variants[0]);
  const canPurchase = variant => Boolean(variant?.available && variant.price > 0);

  function purchaseComplement() {
    const section = $('[data-cocon-complement]');
    const isSelected = Boolean(section && $('[data-complement-selected]', section)?.checked);
    if (!isSelected) return { isSelected: false, price: 0, available: true };
    const selector = $('[data-complement-variant]', section);
    const option = selector?.selectedOptions[0];
    const quantity = $('[data-complement-quantity]', section);
    const rawMax = Number(option?.dataset.max);
    const maximum = Number.isFinite(rawMax) ? Math.max(0, Math.floor(rawMax)) : 99;
    const count = Math.min(Math.max(1, Math.floor(Number(quantity?.value) || 1)), Math.max(1, maximum));
    const price = Math.max(0, Number(option?.dataset.complementPrice) || 0);
    const id = Number(option?.value);
    return { isSelected: true, id, quantity: count, price: price * count, available: Boolean(option && !option.disabled && maximum > 0 && price > 0 && Number.isSafeInteger(id) && id > 0) };
  }

  function purchaseOpenComplements() {
    const empty = { isSelected: false, items: [], price: 0, available: true };
    if (!openComplementRoot) return empty;
    const api = window.CoconOpenComplements?.get(openComplementRoot);
    if (!api) return empty;
    const selection = api.getState();
    const items = (selection.items || []).map(item => {
      const id = Number(item.id);
      const quantity = Number(item.quantity);
      const priceCents = Number(item.priceCents);
      const valid = Number.isSafeInteger(id) && id > 0 && Number.isSafeInteger(quantity) && quantity >= 1 && quantity <= 999 && Number.isSafeInteger(priceCents) && priceCents > 0;
      return { ...item, id, quantity, priceCents, available: valid && item.available !== false };
    });
    return {
      isSelected: items.length > 0,
      items,
      price: items.reduce((total, item) => total + (item.available ? item.priceCents * item.quantity : 0), 0),
      available: selection.canAdd !== false && items.every(item => item.available)
    };
  }

  function purchasePack(variant) {
    if (!packFormulas) return null;
    const api = window.KitteenPackFormulas?.get(packFormulas) || window.KitteenPackFormulas?.init(packFormulas);
    if (!api) return null;
    let selection = api.getState();
    if (variant && String(selection.primaryVariant.id) !== String(variant.id)) {
      api.setPrimaryVariant(variant.id);
      selection = api.getState();
    }
    const isSelected = selection.selected === 'pack';
    const companion = selection.companionVariant;
    const id = Number(companion?.id);
    const price = Math.max(0, Math.round(Number(companion?.priceCents) || 0));
    const primaryMatches = Boolean(variant && String(selection.primaryVariant.id) === String(variant.id));
    return {
      ...selection,
      isSelected,
      companionId: id,
      companionPrice: price,
      available: primaryMatches && Boolean(selection.canAdd) && (!isSelected || (companion?.available !== false && price > 0 && Number.isSafeInteger(id) && id > 0))
    };
  }

  function setPackBusy() {
    if (!packFormulas) return;
    $$('input,select', packFormulas).forEach(control => {
      if (adding) {
        if (!control.hasAttribute('data-cocon-busy-disabled')) control.dataset.coconBusyDisabled = String(control.disabled);
        if (!control.disabled) control.disabled = true;
      } else if (control.hasAttribute('data-cocon-busy-disabled')) {
        control.disabled = control.dataset.coconBusyDisabled === 'true';
        delete control.dataset.coconBusyDisabled;
      }
    });
  }

  function packOptionText(selection, variant, fallback) {
    if (!selection?.isSelected || !variant) return fallback;
    const companion = selection.companionVariant;
    if (product?.handle?.startsWith('gamelle-')) return 'Couleurs : ' + variant.title + ' + ' + companion.title;
    const packName = selection.packName || '';
    const companionText = packName === 'Pack Repas & Eau' ? 'Fontaine inox' : (product?.handle?.startsWith('coupe-griffes-') ? 'Tondeuse blanche' : 'Coupe-griffes : ' + companion.title);
    return (variant.title !== 'Default Title' ? 'Couleur : ' + variant.title + ' · ' : '') + companionText;
  }

  function purchaseFormula(variant) {
    const isPack = Boolean(formulas && $('input[value="pack"]', formulas)?.checked);
    const filterPrice = Number(formulas?.dataset.filterPrice || 0);
    const complement = purchaseComplement();
    const openComplements = purchaseOpenComplements();
    const kit = purchasePack(variant);
    return {
      isPack,
      complement,
      openComplements,
      kit,
      price: (kit?.isSelected ? kit.totalCents : (variant?.price || 0)) + (isPack ? filterPrice : 0) + complement.price + openComplements.price,
      available: canPurchase(variant) && complement.available && openComplements.available && (!isPack || (formulas.dataset.filterAvailable === 'true' && filterPrice > 0)) && (!kit || kit.available)
    };
  }

  function combinedAddition(variant, quantity, payload, formula, drawer) {
    if (!formula.isPack && !formula.complement.isSelected && !formula.kit?.isSelected && !formula.openComplements.isSelected) return payload;
    const properties = {};
    for (const [name, value] of payload.entries()) {
      const match = name.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    }
    const item = { id: Number(variant.id), quantity };
    if (Object.keys(properties).length) item.properties = properties;
    const sellingPlan = Number(payload.get('selling_plan'));
    if (Number.isSafeInteger(sellingPlan) && sellingPlan > 0) item.selling_plan = sellingPlan;
    const items = [item];
    if (formula.isPack) items.push({ id: Number(formulas.dataset.filterVariant), quantity });
    if (formula.complement.isSelected) items.push({ id: formula.complement.id, quantity: formula.complement.quantity });
    if (formula.kit?.isSelected) {
      const companion = items.find(current => current.id === formula.kit.companionId);
      if (companion) companion.quantity += quantity;
      else items.push({ id: formula.kit.companionId, quantity });
    }
    formula.openComplements.items.forEach(addition => {
      const existing = items.find(current => current.id === addition.id);
      if (existing) existing.quantity += addition.quantity;
      else items.push({ id: addition.id, quantity: addition.quantity });
    });
    return { items, ...(drawer ? { sections: ['cocon-cart-drawer'], sections_url: route('cart') } : {}) };
  }

  function syncVariantLinks(variant) {
    if (!variant) return;
    $$('a.release-color-link').forEach(link => {
      const id = new URL(link.href, location.href).searchParams.get('variant');
      link.setAttribute('aria-current', String(id === variant.id));
    });
  }

  function selectLinkedVariant(variant, updateUrl = true) {
    if (!variant || !field) return;
    field.value = variant.id;
    field.dispatchEvent(new Event('change', { bubbles: true }));
    syncVariantLinks(variant);
    if (updateUrl) {
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      url.searchParams.delete('couleur');
      history.replaceState(null, '', url);
    }
    document.dispatchEvent(new CustomEvent('cocon:variant-selected', { detail: { variant, productId: product.id } }));
    syncPurchase();
    schedule();
  }

  function syncReleaseData() {
    if (!product) return;
    const requested = new URLSearchParams(location.search).get('variant');
    const current = product.variants.find(variant => variant.id === requested) || selected() || product.variants.find(canPurchase) || product.variants[0];
    if (current && field) field.value = current.id;
    const native = $('#native-product-data');
    if (native) native.textContent = JSON.stringify(product);
    $$('[data-camera65-data],[data-antiblocage4-data],[data-accessory-data],[data-chantier-variants]').forEach(node => {
      const data = parse(node);
      if (!data) return;
      const variants = Array.isArray(data) ? data : Array.isArray(data.variants) ? data.variants : Object.values(data.variants || {});
      variants.forEach(variant => {
        const fresh = product.variants.find(item => item.id === String(variant.id));
        if (!fresh) { variant.available = false; return; }
        variant.id = fresh.id;
        variant.price = node.hasAttribute('data-chantier-variants') ? money(fresh.price) : fresh.price / 100;
        variant.compareAtPrice = fresh.compare_at_price / 100;
        variant.available = fresh.available;
      });
      if (!Array.isArray(data)) {
        data.currency = currency();
        data.comingSoon = product.variants.every(variant => variant.price <= 0);
        data.selectedId = current?.id;
        if (data.variants && !Array.isArray(data.variants)) {
          const key = Object.keys(data.variants).find(name => String(data.variants[name].id) === current?.id);
          if (key) data.selectedColour = key;
        }
      }
      node.textContent = JSON.stringify(data);
    });
    const color = norm(current?.option1) === 'noir' ? 'black' : 'white';
    $$('[data-initial-color]').forEach(node => node.dataset.initialColor = color);
    syncVariantLinks(current);
  }

  function notice(message, { error = false, cartLink = false } = {}) {
    let node = $('#cocon-notice');
    if (!node) {
      node = document.createElement('div');
      node.id = 'cocon-notice';
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      document.body.append(node);
    }
    node.setAttribute('role', error ? 'alert' : 'status');
    node.innerHTML = escape(message) + (cartLink ? ' <a href="' + escape(route('cart')) + '">Voir le panier →</a>' : '');
    node.hidden = false;
    clearTimeout(window.coconNoticeTimer);
    window.coconNoticeTimer = setTimeout(() => node.hidden = true, error ? 9000 : 5000);
  }

  function purchaseError(message = '') {
    const node = $('#purchase-note', form?.closest('main') || document) || $('.price-note', form || document);
    if (node) { node.textContent = message; node.hidden = !message; }
    if (message) notice(message, { error: true });
  }

  async function request(path, body) {
    const response = await fetch(route(path), {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json', ...(body && !(body instanceof FormData) ? { 'Content-Type': 'application/json' } : {}) },
      ...(body ? { body: body instanceof FormData ? body : JSON.stringify(body) } : {})
    });
    let data;
    try { data = await response.json(); } catch { throw new Error('La boutique n’a pas pu répondre. Réessayez dans un instant.'); }
    if (!response.ok || data?.status >= 400) throw new Error(data?.description || data?.message || 'Cette modification n’a pas pu être effectuée. Réessayez.');
    return data;
  }

  function paintCount() {
    if (!cart) return;
    $$('.cart-count,[data-cocon-cart-count]').forEach(node => { node.textContent = String(cart.item_count || 0); node.hidden = !cart.item_count; });
  }

  async function refreshCart({ announce = false, sections = null } = {}) {
    cart = await request('cart.js');
    paintCount();
    renderCart();
    document.dispatchEvent(new CustomEvent('cocon:cart-updated', { detail: { cart, sections } }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    if (announce) notice('Panier mis à jour.');
    return cart;
  }

  async function addProduct() {
    const variant = selected();
    const formula = purchaseFormula(variant);
    if (adding || !form || !field || !formula.available) return;
    adding = true;
    document.dispatchEvent(new CustomEvent('cocon:purchase-busy', { detail: { busy: true } }));
    purchaseError();
    syncPurchase();
    let payload = new FormData(form);
    payload.set('id', variant.id);
    const quantity = Math.max(1, Math.min(999, Math.floor(Number(payload.get('quantity')) || 1)));
    payload.set('quantity', String(quantity));
    if ($('#cocon-cart-drawer')) {
      payload.set('sections', 'cocon-cart-drawer');
      payload.set('sections_url', route('cart'));
    }
    payload = combinedAddition(variant, quantity, payload, formula, Boolean($('#cocon-cart-drawer')));
    try {
      const added = await request('cart/add.js', payload);
      try { await refreshCart({ sections: added.sections }); } catch {
        notice('Produit ajouté. Vous pouvez consulter votre panier.', { cartLink: true });
        return;
      }
      if ($('#cocon-cart-drawer')) document.dispatchEvent(new CustomEvent('cocon:cart-open', { detail: { trigger: document.activeElement } }));
      else notice('Ajouté au panier.', { cartLink: true });
    } catch (error) {
      purchaseError(error.message);
    } finally {
      adding = false;
      document.dispatchEvent(new CustomEvent('cocon:purchase-busy', { detail: { busy: false } }));
      syncPurchase();
    }
  }

  function textIfChanged(node, text) { if (node && node.textContent !== text) node.textContent = text; }

  function syncDelivery(formula) {
    const range = delayedDeliveryHandles.has(product?.handle) || (product?.handle === 'fontaine-eau-chat-inox-2-2l' && formula.isPack) ? '6 à 10' : '3 à 8';
    $$('[data-cocon-delivery-range]').forEach(node => textIfChanged(node, range));
  }

  function syncPurchase() {
    if (!product || !primary) return;
    const variant = selected();
    const pending = Boolean(variant && variant.price <= 0);
    const formula = purchaseFormula(variant);
    syncDelivery(formula);
    setPackBusy();
    const available = formula.available;
    const label = pending ? 'Bientôt disponible' : available ? 'Ajouter au panier' : 'Indisponible';
    const formatted = variant ? money(formula.price) : '';
    if (formulas) $$('[data-formula-card]', formulas).forEach(card => card.classList.toggle('is-selected', $('input', card).checked));
    if (primary.hasAttribute('data-cocon-primary')) {
      const spans = [...(primary.children || [])];
      const validStructure = spans.length === (available ? 2 : 1) && spans.every(node => node.tagName === 'SPAN') && (!available || String(spans[1].className).split(/\s+/).includes('cocon-button-price'));
      if (!validStructure) primary.innerHTML = available ? '<span>Ajouter au panier</span><span class="cocon-button-price">' + escape(formatted) + '</span>' : '<span>' + label + '</span>';
      else {
        textIfChanged(spans[0], label);
        if (available) textIfChanged(spans[1], formatted);
      }
    }
    if (primary.disabled !== (!available || adding)) primary.disabled = !available || adding;
    primary.setAttribute('aria-busy', String(adding));
    const scope = $('#MainContent') || document;
    const nextAvailabilityKey = variant ? variant.id + ':' + variant.price + ':' + variant.available : 'none';
    if (form?.classList.contains('native-product-form') && availabilityKey !== nextAvailabilityKey) {
      availabilityKey = nextAvailabilityKey;
      textIfChanged($('#product-availability', scope), !variant ? 'Indisponible' : pending ? 'En préparation' : !variant.available ? 'Indisponible' : '');
      textIfChanged($('.price-note', form), !variant ? 'Choisissez une autre combinaison.' : pending ? 'Le prix sera affiché à l’ouverture des commandes.' : !variant.available ? 'Cette variante est actuellement indisponible.' : '');
    }
    $$('[data-price],#product-price,.buybox .price-main>strong,.product-buybox .price-line>strong,.product-buybox .inox-price>strong', scope).forEach(node => {
      textIfChanged(node, pending ? 'Bientôt disponible' : variant ? (packFormulas || formula.openComplements.isSelected || (formula.complement.isSelected && !formula.isPack)) ? money(variant.price) : formatted : 'Indisponible');
      if (!node.closest('button,a,.cocon-sticky')) {
        node.classList.toggle('cocon-fish-price', Boolean(variant && variant.price > 0));
        node.parentElement?.classList.add('cocon-fish-price-row');
      }
    });
    const discounted = Boolean(!formula.isPack && variant && variant.price > 0 && variant.compare_at_price > variant.price);
    $$('[data-compare-price],#product-compare-price,.buybox .compare-price,.product-buybox .inox-price>s', scope).forEach(node => {
      textIfChanged(node, discounted ? money(variant.compare_at_price) : '');
      node.hidden = !discounted;
    });
    $$('[data-discount],#product-discount,.buybox .discount-pill,.product-buybox .inox-discount', scope).forEach(node => {
      textIfChanged(node, discounted ? '−' + Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100) + ' %' : '');
      node.hidden = !discounted;
    });
    if (!sticky) return;
    textIfChanged($('[data-cocon-sticky-price]', sticky), pending ? 'Bientôt disponible' : variant ? formatted : 'Indisponible');
    const values = product.options.map(option => ({ name: option.name, value: variant?.options[option.position - 1] })).filter(option => option.value && option.value !== 'Default Title' && option.name !== 'Title');
    const option = $('[data-cocon-sticky-option]', sticky);
    const baseOptionText = formulas ? 'Gris inox' + (formula.isPack ? ' · +15 filtres' : '') : values.map(item => item.name + ' : ' + item.value).join(' · ');
    const count = formula.openComplements.items.length;
    const openOptionText = count ? ' · ' + count + ' complément' + (count > 1 ? 's' : '') : '';
    const optionText = packOptionText(formula.kit, variant, baseOptionText) + (formula.complement.isSelected ? ' · + sacs' : '') + openOptionText;
    textIfChanged(option, optionText);
    if (option) option.hidden = !optionText;
    const button = $('.cocon-sticky-add', sticky);
    if (button) { textIfChanged(button, label); button.disabled = !available || adding; button.setAttribute('aria-busy', String(adding)); }
  }

  function updateSticky() {
    if (!sticky || !primary) return;
    const rect = primary.getBoundingClientRect();
    const header = $('header.header')?.getBoundingClientRect();
    const inset = Math.max(0, header?.bottom || 0);
    const visible = rect.top >= inset && rect.bottom <= innerHeight && rect.right > 0 && rect.left < innerWidth;
    const modal = $('dialog[open]');
    const keyboard = window.visualViewport && innerHeight - window.visualViewport.height > 150;
    const hidden = visible || Boolean(modal) || Boolean(keyboard);
    // Read an already visible bar before writing any layout-affecting state.
    const height = !hidden && !sticky.hidden ? sticky.offsetHeight : 0;
    if (sticky.hidden !== hidden) sticky.hidden = hidden;
    if (document.body.classList.contains('cocon-sticky-active') !== !hidden) {
      document.body.classList.toggle('cocon-sticky-active', !hidden);
    }
    if (!hidden) {
      const nextHeight = (height || sticky.offsetHeight) + 'px';
      if (document.body.style.getPropertyValue('--cocon-sticky-height') !== nextHeight) {
        document.body.style.setProperty('--cocon-sticky-height', nextHeight);
      }
    }
  }

  function schedule() {
    if (paintFrame) return;
    paintFrame = requestAnimationFrame(() => { paintFrame = 0; syncPurchase(); updateSticky(); });
  }

  function chooseVariantFromButton(button) {
    if (!product || !field || !button?.hasAttribute('data-color')) return;
    const color = button.dataset.color === 'black' ? 'noir' : button.dataset.color === 'white' ? 'blanc' : norm(button.dataset.color);
    const next = product.variants.find(variant => variant.options.some(value => norm(value) === color));
    if (!next) return;
    field.value = next.id;
    field.dispatchEvent(new Event('change', { bubbles: true }));
    const url = new URL(location.href);
    url.searchParams.set('variant', next.id);
    history.replaceState(null, '', url);
  }

  function renderCart() {
    const container = $('.refonte-cart');
    if (!container || !cart) return;
    const focused = document.activeElement;
    const focusKey = focused?.dataset.quantity || focused?.dataset.remove;
    const delta = focused?.dataset.delta;
    $$('.cocon-cart-demo', container).forEach(node => node.remove());
    const empty = $('.empty-cart', container);
    if (empty) { empty.hidden = cart.item_count > 0; empty.style.removeProperty('display'); }
    if (!cart.items?.length) return;
    const panel = document.createElement('div');
    panel.className = 'cocon-cart-demo';
    const cartCurrency = cart.currency || currency();
    panel.innerHTML = '<div class="cart-lines">' + cart.items.map(item => {
      const image = item.featured_image?.url || item.image || '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      const properties = Object.entries(item.properties || {}).filter(([name, value]) => !name.startsWith('_') && value).map(([name, value]) => '<p class="cart-property">' + escape(name) + ' : ' + escape(value) + '</p>').join('');
      return '<article class="cart-line"><a class="cocon-cart-photo" href="' + escape(item.url) + '">' + (image ? '<img src="' + escape(image) + '" alt="' + escape(item.featured_image?.alt || item.product_title) + '" loading="lazy">' : '') + '</a><div><a href="' + escape(item.url) + '"><h2>' + escape(item.product_title) + '</h2></a><p>' + escape(variant) + '</p>' + properties + '<div class="cocon-quantity"><button type="button" data-quantity="' + escape(item.key) + '" data-delta="-1" aria-label="Retirer une unité">−</button><span>' + item.quantity + '</span><button type="button" data-quantity="' + escape(item.key) + '" data-delta="1" aria-label="Ajouter une unité">+</button></div><button type="button" class="text-link" data-remove="' + escape(item.key) + '">Retirer</button></div><strong>' + money(item.final_line_price, cartCurrency) + '</strong></article>';
    }).join('') + '</div><aside class="cart-summary"><h2>Votre panier</h2><div class="cocon-cart-total"><span>Total</span><strong>' + money(cart.total_price, cartCurrency) + '</strong></div><p>Livraison offerte en France métropolitaine</p><form method="post" action="' + escape(route('cart')) + '"><button type="submit" name="checkout" class="button">Passer à la commande</button></form><small>30 jours pour l’essayer avec votre chat</small></aside>';
    container.append(panel);
    if (focusKey) {
      const next = $$('[data-quantity],[data-remove]', panel).find(node => (node.dataset.quantity || node.dataset.remove) === focusKey && node.dataset.delta === delta);
      next?.focus({ preventScroll: true });
    }
  }

  async function changeCart(button) {
    if (changing) return;
    const key = button.dataset.remove || button.dataset.quantity;
    changing = true;
    let line = cart?.items?.find(item => item.key === key);
    if (!line) {
      try { await refreshCart(); line = cart?.items?.find(item => item.key === key); }
      catch (error) { notice(error.message, { error: true }); }
      if (!line) { changing = false; return; }
    }
    const quantity = button.dataset.remove ? 0 : Math.max(0, line.quantity + Number(button.dataset.delta || 0));
    const panel = $('.refonte-cart');
    $$('[data-quantity],[data-remove]', panel || document).forEach(node => node.disabled = true);
    if (panel) panel.setAttribute('aria-busy', 'true');
    try {
      cart = await request('cart/change.js', { id: key, quantity });
      paintCount();
      renderCart();
      document.dispatchEvent(new CustomEvent('cocon:cart-updated', { detail: { cart } }));
    } catch (error) {
      notice(error.message, { error: true });
      try { await refreshCart(); } catch {}
    } finally {
      changing = false;
      $$('[data-quantity],[data-remove]', panel || document).forEach(node => node.disabled = false);
      if (panel) panel.setAttribute('aria-busy', 'false');
    }
  }

  async function clearCart() {
    if (changing) return;
    changing = true;
    try {
      cart = await request('cart/clear.js', {});
      paintCount();
      renderCart();
      document.dispatchEvent(new CustomEvent('cocon:cart-updated', { detail: { cart } }));
    } catch (error) { notice(error.message, { error: true }); }
    finally { changing = false; }
  }

  formulas?.addEventListener('change', schedule);
  document.addEventListener('kitteen:formula-change', event => { if (event.target === packFormulas) schedule(); });
  document.addEventListener('cocon:purchase-complement-changed', schedule);
function restoreContextLinks() {
  'use strict';
  const main = document.getElementById('MainContent');
  const data = document.getElementById('cocon-product-data');
  if (!main || !data) return;
  let handle;
  try { handle = JSON.parse(data.textContent).handle; } catch { return; }
  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const policies = {
    'Conditions de livraison': '/policies/shipping-policy',
    'Conditions de retour': '/policies/refund-policy',
    'Consulter les conditions de retour': '/policies/refund-policy',
    'Conditions d’essai et de remboursement': '/policies/refund-policy',
    'Voir les conditions d’essai et de remboursement →': '/policies/refund-policy',
    'conditions de retour': '/policies/refund-policy',
    "Conditions des 30 jours d'essai": '/policies/refund-policy'
  };
  const actions = {
    'distributeur-croquettes-automatique-chat-2l-boutons': {
      '4 L à boutons': '/products/distributeur-croquettes-automatique-chat-4l-anti-blocage',
      'La ration : choisir, tester puis ajuster': '#portions'
    },
    'distributeur-croquettes-automatique-chat-2l-camera': {
      'Voir comment tester et ajuster ses portions.': '#repas'
    },
    'distributeur-croquettes-automatique-chat-2l-wifi': {
      'Voir comment ajuster les repas avec ses croquettes.': '#programmation'
    },
    'distributeur-croquettes-automatique-chat-4l-anti-blocage': {
      'Voir le distributeur à boutons 2 L': '/products/distributeur-croquettes-automatique-chat-2l-boutons'
    },
    'distributeur-croquettes-automatique-chat-camera-6-5l': {
      'Voir le modèle caméra 2 L': '/products/distributeur-croquettes-automatique-chat-2l-camera'
    },
    'fontaine-eau-chat-3l-sans-filtre-sans-fil': {
      'Voir ce que cela change au quotidien.': '#fonctionnement',
      'Explorez les volumes et les intervalles dans le simulateur.': '#reglages',
      'fontaine inox 2,2 L': '/products/fontaine-eau-chat-inox-2-2l',
      'Consultez les consignes de nettoyage': '#entretien'
    },
    'fontaine-eau-chat-inox-2-2l': {
      'Retrouvez les trois gestes d’entretien': '#inox-entretien'
    },
    'litiere-automatique-autonettoyante-chat-bac-ouvert': {
      'Voir les gestes pour accompagner la transition.': '#transition',
      'Retrouvez les gestes de vidage et d’entretien.': '#entretien',
      'Consultez les gestes d’entretien': '#entretien'
    },
    'litiere-automatique-autonettoyante-chat-fermee': {
      'Les trois gestes d’entretien': '#entretien',
      'personnaliser les délais et les horaires': '#reglages',
      'Voir son fonctionnement et les gestes qui le complètent.': '#fonctionnement',
      'les critères pour votre chat': '#compatibilite',
      'Suivez les gestes de nettoyage': '#entretien',
      'consultez les consignes de sécurité par mode': '#securite'
    }
  };
  main.querySelectorAll('span.cocon-inert-note').forEach(node => {
    const text = node.textContent.replace(/\s+/g, ' ').trim();
    const target = policies[text] || actions[handle]?.[text];
    if (!target || (target.startsWith('#') && !document.getElementById(target.slice(1)))) return;
    const link = document.createElement('a');
    for (const attribute of node.attributes) link.setAttribute(attribute.name, attribute.value);
    link.classList.remove('cocon-inert-note');
    link.classList.add('cocon-policy-link');
    link.setAttribute('href', target.startsWith('#') ? target : root + target.replace(/^\//, ''));
    link.replaceChildren(...node.childNodes);
    node.replaceWith(link);
  });
}

  restoreContextLinks();
  syncReleaseData();
  document.addEventListener('cocon:cart-updated', event => {
    if (!event.detail?.cart) return;
    cart = event.detail.cart;
    paintCount();
    if (event.detail.fromDrawer) renderCart();
  });
  document.addEventListener('submit', event => {
    if (event.target !== form || !product) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addProduct();
  }, true);
  document.addEventListener('click', event => {
    const button = event.target.closest('button,a');
    if (!button) return;
    if (button.matches('.cocon-sticky-add')) { event.preventDefault(); addProduct(); return; }
    if (button.matches('.cocon-return')) {
      event.preventDefault();
      ($('#product-buy') || $('#MainContent')).scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      return;
    }
    if (button.hasAttribute('data-quantity') || button.hasAttribute('data-remove')) {
      event.preventDefault();
      changeCart(button);
      return;
    }
    if (button.hasAttribute('data-cocon-clear')) { event.preventDefault(); clearCart(); return; }
    if (button.matches('a.release-color-link') && product && field && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
      const id = new URL(button.href, location.href).searchParams.get('variant');
      const variant = product.variants.find(item => item.id === id);
      if (variant) { event.preventDefault(); selectLinkedVariant(variant); return; }
    }
    if (button.hasAttribute('data-color')) chooseVariantFromButton(button);
    if (button.matches('[data-color],[data-variant],[data-option-value]')) schedule();
  });
  let stickyFrame = 0;
  window.addEventListener('scroll', () => {
    if (stickyFrame) return;
    stickyFrame = requestAnimationFrame(() => { stickyFrame = 0; updateSticky(); });
  }, { passive: true });
  window.addEventListener('resize', schedule);
  window.visualViewport?.addEventListener('resize', schedule);
  window.addEventListener('popstate', () => {
    if ($('a.release-color-link') && product) {
      const id = new URLSearchParams(location.search).get('variant');
      selectLinkedVariant(product.variants.find(item => item.id === id) || product.variants[0], false);
    } else queueMicrotask(schedule);
  });
  window.addEventListener('pageshow', event => { if (event.persisted) refreshCart().catch(() => {}); });
  if (form) {
    new MutationObserver(schedule).observe(form, { attributes: true, subtree: true, childList: true, attributeFilter: ['value', 'disabled', 'aria-pressed', 'aria-current'] });
    form.addEventListener('change', schedule);
    form.addEventListener('click', schedule);
  }
  if (sticky) new MutationObserver(schedule).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
  syncPurchase();
  schedule();
  window.addEventListener('load', () => {
    $$('.mobile-purchase,.chantier-mobile-cart').forEach(node => node.hidden = true);
    const requested = new URLSearchParams(location.search).get('variant');
    if (requested && product && form?.classList.contains('native-product-form')) {
      const variant = product.variants.find(item => item.id === requested);
      if (variant) product.options.forEach(option => {
        const section = $('[data-option-index="' + (option.position - 1) + '"]', form);
        $$('[data-option-value]', section || form).find(button => button.dataset.optionValue === variant.options[option.position - 1])?.click();
      });
    }
    schedule();
    refreshCart().catch(error => { if ($('.refonte-cart')) notice(error.message, { error: true }); });
  });
})();
